import data from './data'
import components from './components'
import mounted from './mounted'
import validations from './validations'

export default {
  data,
  mounted,
  components,
  validations,

  /* route API for professional agenda */
  resourcePath: '/v1/professional/agendas/agendas'
}



// WEBPACK FOOTER //
// ./src/app/professional/agenda/agendas/resources/index.js